import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import copy from 'copy-to-clipboard';
import { MenuItem } from 'material-ui';
import EmailIcon from 'material-ui/svg-icons/communication/email';
import { getContractForwardingEmail } from '../../../stores/contracting/contract-list/contract-list-actions';
import WallWrapper from '../../wall/wrapper';

class ContractMailbox extends Component {
  componentWillReceiveProps(newProps) {
    // copy to clipboard if the address is loaded
    if (newProps.contractMailboxMailbox && this.props.contractMailboxLoding && !newProps.contractMailboxLoding) {
      copy(newProps.contractMailboxMailbox);
      this.props.showMessage('Email address copied to the clipboard');
    }
  }
  render() {
    const { contractId } = this.props;
    return (
      <WallWrapper slug="upgrade-page-contracting-workflow-fwd" amazonOrange>
        <MenuItem
          style={{ fontSize: '15px', minHeight: '32px', lineHeight: '32px' }}
          innerDivStyle={{ padding: '0px 24px 0px 64px' }}
          leftIcon={(
            <EmailIcon
              color="rgba(0, 0, 0, 0.84)"
              style={{
                top: '4px',
                margin: '0',
                left: '24px',
                fill: 'rgb(117, 117, 117)',
              }}
            />
          )}
          primaryText="Get forwarding email address for this workspace"
          onTouchTap={() => {
            this.props.getContractForwardingEmail(contractId);
          }}
        />
      </WallWrapper>
    );
  }
}

ContractMailbox.propTypes = {
  contractId: PropTypes.string,
  contractMailboxLoding: PropTypes.bool,
  contractMailboxMailbox: PropTypes.string,
  getContractForwardingEmail: PropTypes.func,
  showMessage: PropTypes.func,
};

const mapStateToProps = ({ contracting, user }, ownProps) => ({
  contractMailboxLoding: contracting.contractList.getIn(['contractMailboxes', ownProps.contractId, 'loading']),
  contractMailboxMailbox: contracting.contractList.getIn(['contractMailboxes', ownProps.contractId, 'mailbox']),
});

export default connect(mapStateToProps, {
  showMessage: payload => ({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload }),
  getContractForwardingEmail,
})(ContractMailbox);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/contractMailbox.jsx